export type EnvSettingsType =
  | 'REACT_APP_PB_AUTH_URL'
  | 'REACT_APP_PB_AUTH_SCOPE'
  | 'REACT_APP_PB_AUTH_CLIENT_ID'
  | 'REACT_APP_PB_API_TIMEOUT'
  | 'REACT_APP_PB_CDN_BASE_URL'
  | 'REACT_APP_PB_GRAPH_BASE_URL'
  | 'REACT_APP_PB_AUTH_AUTOMATIC_SILENT_RENEW'
  | 'REACT_APP_PB_AUTH_SILENT_REQUEST_TIMEOUT'
  | 'REACT_APP_PB_AUTH_REDIRECT_URI'
  | 'REACT_APP_PB_AUTH_SILENT_REDIRECT_URI'
  | 'REACT_APP_PB_AUTH_POST_LOGOUT_REDIRECT_URI'
  | 'REACT_APP_PB_POS_URL'
  | 'REACT_APP_PB_FINGERPRINT_PRO_KEY'
  | 'REACT_APP_PB_API_LOTTERY_BASE_URL'
  | 'REACT_APP_PB_API_TICKET_INQUIRY_BASE_URL'
  | 'OIDC_STORAGE_KEY'
  | 'NOC_DISPLAY_BASE_URL'
  | 'REACT_APP_PB_API_BASE_URL'

export const getEnvSettings = () => {
  // DEV
  // const envSettings: Record<EnvSettingsType | any, string | undefined> = {
  //   REACT_APP_PB_AUTH_URL: 'https://idp.microsuave.com',
  //   REACT_APP_PB_AUTH_SCOPE: 'openid profile placebet-administration',
  //   REACT_APP_PB_AUTH_CLIENT_ID: 'placebet-admin',
  //   REACT_APP_PB_API_TIMEOUT: '30000',
  //   REACT_APP_PB_GRAPH_BASE_URL: 'https://router.microsuave.com',
  //   REACT_APP_PB_POS_URL: 'https://dev.microsuave.com',
  //   REACT_APP_PB_FINGERPRINT_PRO_KEY: 'UQreLvVEdQFIupF6P2FP',
  //   REACT_APP_PB_API_LOTTERY_BASE_URL: 'https://premiado-webhook.microsuave.com',
  //   REACT_APP_PB_API_TICKET_INQUIRY_BASE_URL: 'https://ticket-inquiry-webhook.microsuave.com',
  //   OIDC_STORAGE_KEY: 'oidc.user:https://idp.microsuave.com:placebet-admin',
  //   NOC_DISPLAY_BASE_URL: 'https://noc-display-service.microsuave.com',
  //   REACT_APP_PB_API_BASE_URL: 'https://secure.microsuave.com',
  // }

  // PROD
  const envSettings: Record<EnvSettingsType | any, string | undefined> = {
    REACT_APP_PB_AUTH_URL: 'https://idp.autentica.do',
    REACT_APP_PB_AUTH_SCOPE: 'openid profile placebet-administration',
    REACT_APP_PB_AUTH_CLIENT_ID: 'placebet-admin',
    REACT_APP_PB_API_TIMEOUT: '30000',
    REACT_APP_PB_GRAPH_BASE_URL: 'https://router.placebet.com.do',
    REACT_APP_PB_POS_URL: 'https://dev.placebet.com.do',
    REACT_APP_PB_FINGERPRINT_PRO_KEY: 'UQreLvVEdQFIupF6P2FP',
    REACT_APP_PB_API_LOTTERY_BASE_URL: 'https://premiado-webhook.placebet.com.do',
    REACT_APP_PB_API_TICKET_INQUIRY_BASE_URL: 'https://ticket-inquiry-webhook.placebet.com.do',
    OIDC_STORAGE_KEY: 'oidc.user:https://idp.autentica.do:placebet-admin',
    NOC_DISPLAY_BASE_URL: 'https://noc-display-service.placebet.com.do',
    REACT_APP_PB_API_BASE_URL: 'https://secure.placebet.com.do',
  }

  var buildSettings = (window as any)['_env_'] as any

  Object.keys(envSettings).forEach((key) => {
    const value = buildSettings[key] || process.env[key]
    if (value) {
      envSettings[key] = value
    }
  })

  return envSettings
}

export const isMobile = (): boolean => {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true
  } else {
    return false
  }
}
